export const resources = {
    PositionTitles: {
        BranchManager: "Branch Manager",
        ChiefExecutiveOfficer: "CEO",
        ChiefFinancialOfficer: "CFO",
        ExecutiveVicePresident: "EVP",
        ExecutiveVicePresidentSharedServices: 'EVP - Shared Services',
        RegionalPresident: 'Regional President'
    }
}
